import { apiCall } from "./authServices";

export const GetDropdownData = async () => {
    try {
        const endpoint = `api/dashboard/filtration-parameters`
        const res = await apiCall({
            endpoint: endpoint,
            method: "GET",
        });
        if (res.success) {
  
            if (res.locationData && res.locationData.length) {
                const { regions, zones, areas, dealerCodeName } = formattedRegion(res.locationData)
                res.regions = regions
                res.zones = zones
                res.areas = areas
                res.dealerCodeName = dealerCodeName
            }

            if (res.financialYears && res.financialYears.length) {
                const arr = []
                res.financialYears.forEach(el => {
                    arr.push({ value: el, label: el })
                })
                res.financialYears = arr
            }

            if (res.mvrPeriods && res.mvrPeriods.length) {
                const arr = []
                res.mvrPeriods.forEach(el => {
                    arr.push({ value: el, label: el })
                })
                res.periods = arr
            }
            
            if (res.bmvrFrequency && res.bmvrFrequency.length) {
                const arr = []
                res.bmvrFrequency.forEach(el => {
                    arr.push({ value: el, label: el })
                })
                res.frequency = arr
            }
            
        }
        return res
    } catch (error) {
        throw error;
    }
}

const formattedRegion = (locationData) => {
    if (locationData && locationData.length) {
        const regions = []
        const zones = []
        const areas = []
        const dealerCodeName = []
        locationData.forEach((el, index) => {
            if (regions.findIndex(region => region.value === el.region) === -1) {
                regions.push({ value: el.region, label: el.region })
            }
            if (zones.findIndex(zone => zone.value === el.zone) === -1) {
                zones.push({ value: el.zone, label: el.zone, region: el.region })
            }
            if (areas.findIndex(area => area.value === el.area) === -1) {
                areas.push({ value: el.area, label: el.area, zone: el.zone, region: el.region })
            }
            if (dealerCodeName.findIndex(dealer => dealer.value === el.dealerCode) === -1) {
                dealerCodeName.push({ value: el.dealerCode, label: el.dealerCodeName, zone: el.zone, area: el.area, region: el.region })
            }
        })
        return { regions, zones, areas, dealerCodeName }
    }
}
